import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "./lib/auth";
import { WorkspaceSession } from './components/WorkspaceSession';
import "./styles.css";
import '@fontsource/noto-sans-myanmar/400.css';
import '@fontsource/noto-sans-myanmar/600.css';

const root = document.getElementById("root");

if (!root) {
  throw new Error("AutoSocial root element is missing.");
}

createRoot(root).render(
  <StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <WorkspaceSession />
      </AuthProvider>
    </BrowserRouter>
  </StrictMode>,
);
